import { connect } from 'react-redux'
import {
    resetCollaborativeIndexationCreationInvalidField,
    updateCollaborativeIndexationFieldValue,
} from '../../../../../../redux/collaborativeIndexations/actions'
import {
    getCollaborativeIndexationCampaignCountries,
    getCollaborativeIndexationCampaignDepartments,
    getCollaborativeIndexationCreationFields,
    isCollaborativeIndexationCreationInvalidField,
} from '../../../../../../redux/collaborativeIndexations/selectors'
import Address from './Address.jsx'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
    resetInvalidField: (field) => dispatch(resetCollaborativeIndexationCreationInvalidField(field))
})

const mapStateToProps = (state, ownProps) => ({
    fields: getCollaborativeIndexationCreationFields(state),
    isInvalidField: (field) => isCollaborativeIndexationCreationInvalidField(state, field),
    departments: getCollaborativeIndexationCampaignDepartments(state),
    countries: getCollaborativeIndexationCampaignCountries(state),
})

export const AddressContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Address)
